module.exports = __webpack_public_path__ + "static/media/cherry-collected.c3acce8d.png";